(function () {
  'use strict';

  const config = window.wineClubConfig || {};
  const wineClubEligible = Boolean(config.eligible);
  const wineClubProductIds = Array.isArray(config.productIds) ? config.productIds.map(Number) : [];

  const cartRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

  let validationPromise = null;
  let lastCartSignature = '';
  let watcherTimer = null;

  async function getCart() {
    const response = await fetch(
      cartRoot + 'cart.js',
      {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Unable to retrieve cart');
    }

    return response.json();
  }

  function getCartSignature(cart) {
    return cart.items
      .map(function (item) {
        return item.key + ':' + item.quantity;
      })
      .join('|');
  }

  async function removeRestrictedProducts(items) {
    if (!items.length) { return null; }

    const updates = {};

    items.forEach(function (item) { updates[item.variant_id] = 0; });

    const response = await fetch(
      cartRoot + 'cart/update.js',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          updates: updates
        })
      }
    );

    const responseText = await response.text();

    if (!response.ok) {
      throw new Error(
        'Unable to remove restricted products'
      );
    }

    return JSON.parse(responseText);
  }

  async function validateCart() {
    if (validationPromise) {
      return validationPromise;
    }
    validationPromise = (async function () {
      try {

        const cart = await getCart();
        const restrictedItems = cart.items.filter(function (item) {
          return wineClubProductIds.includes(
            Number(item.product_id)
          );
        });

        if (!restrictedItems.length) {
          return {
            valid: true,
            removed: false,
            cart: cart
          };
        }

        const updatedCart = await removeRestrictedProducts(restrictedItems);

        if (updatedCart) {
          lastCartSignature = getCartSignature(updatedCart);
          setTimeout(function () {
            window.location.reload();
          }, 300);
        }

        document.dispatchEvent(
          new CustomEvent(
            'wineClub:cartUpdated',
            {
              detail: {
                cart: updatedCart
              }
            }
          )
        );

        return {
          valid: true,
          removed: true,
          cart: updatedCart
        };

      } catch (error) {
        return {
          valid: false,
          removed: false,
          error: error
        };
      } finally {
        validationPromise = null;
      }
    })();

    return validationPromise;
  }

  async function checkForCartChange() {
    if (document.hidden) {
      scheduleWatcher();
      return;
    }

    if (validationPromise) {
      scheduleWatcher();
      return;
    }

    try {
      const cart = await getCart();
      const signature = getCartSignature(cart);

      if (!lastCartSignature) {
        lastCartSignature = signature;
        scheduleWatcher();
        return;
      }

      if (signature !== lastCartSignature) {
        lastCartSignature = signature;
        await validateCart();
      }

    } catch (error) {
    }

    scheduleWatcher();
  }

  function scheduleWatcher() {
    clearTimeout(watcherTimer);

    watcherTimer = setTimeout(
      checkForCartChange,
      750
    );
  }

  function pageGate() {
    if (!/wishlist/i.test(window.location.pathname)) { return false; }  

    const GATE_SELECTOR = '.wls-content';
    const DEBUG = true;                   

    const MAX_WAIT = 6000;  
    const MIN_WAIT_FOR_BUTTONS = 3500;  
    const QUIET_MS = 500;   
    const EXTRA_WAIT_MS = 800;    
    const AGE_LIMIT = 21;
    const HIDE_ALL_WHEN_UNDER_AGE = true; 
    const LOCKED_TITLE = 'Available to wine club members only';

    const BUTTONS = 'button, input[type="submit"], input[type="button"], a.btn, [role="button"]';
    const startedAt = Date.now();
    const idCache = {};

    let revealed = false;
    let validated = false;
    let quietTimer = null;
    let firstButtonsAt = 0;

    const underAge =
      config.underAge === true ||
      (typeof config.age === 'number' && config.age < AGE_LIMIT);

    function getState(productId) {
      if (underAge) {
        if (HIDE_ALL_WHEN_UNDER_AGE) { return 'hide'; }
        if (productId && wineClubProductIds.includes(productId)) { return 'hide'; }
        return null;
      }
      if (!wineClubEligible && productId && wineClubProductIds.includes(productId)) { return 'disable'; }
      return null;
    }

    const hideStyle = document.createElement('style');
    hideStyle.textContent = GATE_SELECTOR + ' [data-wc-hidden]{display:none !important;}';
    (document.head || document.documentElement).appendChild(hideStyle);

    const gate = document.createElement('style');
    gate.textContent =
      GATE_SELECTOR + '{visibility:hidden !important;position:relative !important;min-height:240px !important;}' +
      GATE_SELECTOR + '::after{' +
        'content:"";visibility:visible;position:absolute;top:90px;left:50%;' +
        'width:36px;height:36px;margin-left:-18px;box-sizing:border-box;' +
        'border:3px solid rgba(0,0,0,.12);border-top-color:var(--colorBtnPrimary,#a47e50);' +
        'border-radius:50%;animation:wcGateSpin .8s linear infinite;}' +
      '@keyframes wcGateSpin{to{transform:rotate(360deg);}}';
    (document.head || document.documentElement).appendChild(gate);

    function reveal() {
      if (revealed) { return; }
      revealed = true;
      clearTimeout(quietTimer);
      observer.disconnect();
      gate.remove();
      watchLater();
    }

    setTimeout(reveal, MAX_WAIT);

    function isAddToCart(el) {
      if (!el.matches(BUTTONS)) { return false; }
      const text = (el.value || el.textContent || el.getAttribute('aria-label') || '').trim();
      return /add\s*to\s*(cart|bag)/i.test(text) || el.getAttribute('name') === 'add';
    }

    function findButtons() {
      const found = [];
      document.querySelectorAll(GATE_SELECTOR).forEach(function (area) {
        area.querySelectorAll(BUTTONS).forEach(function (el) {
          if (isAddToCart(el) && found.indexOf(el) === -1) { found.push(el); }
        });
      });
      return found;
    }

    async function resolveProductId(btn) {
      let node = btn.parentElement;
      let link = null;

      while (node && node !== document.body) {
        const withId = node.matches('[data-product-id]') ? node : node.querySelector('[data-product-id]');
        if (withId) { return Number(withId.getAttribute('data-product-id')); }

        link = node.querySelector('a[href*="/products/"]');
        if (link) { break; }
        node = node.parentElement;
      }
      if (!link) { return null; }

      const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!match) { return null; }

      const handle = match[1];
      if (idCache[handle]) { return idCache[handle]; }

      const res = await fetch(cartRoot + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) { return null; }

      const product = await res.json();
      idCache[handle] = Number(product.id);
      return idCache[handle];
    }

    function hideButton(btn) {
      btn.setAttribute('data-wc-hidden', '1');
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
    }

    function disableButton(btn) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('title', LOCKED_TITLE);

      new MutationObserver(function () {
        if (!btn.disabled) { btn.disabled = true; }
      }).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    }

    async function processButtons(buttons) {
      await Promise.all(buttons.map(async function (btn) {
        if (btn.hasAttribute('data-wc-checked')) { return; }
        btn.setAttribute('data-wc-checked', '1');
        try {
          const id = (underAge && HIDE_ALL_WHEN_UNDER_AGE) ? null : await resolveProductId(btn);
          const state = getState(id);

          if (state === 'hide') { hideButton(btn); }
          else if (state === 'disable') { disableButton(btn); }
        } catch (e) {
          log('error', e); 
        }
      }));
    }

    async function finish() {
      if (revealed || !validated) { return; }

      const buttons = findButtons();

      if (buttons.length === 0 && Date.now() - startedAt < MIN_WAIT_FOR_BUTTONS) {
        settle();
        return;
      }

      if (buttons.length > 0) {
        if (!firstButtonsAt) { firstButtonsAt = Date.now(); }
        await processButtons(buttons);

        const waited = Date.now() - firstButtonsAt;
        if (waited < EXTRA_WAIT_MS) {
          clearTimeout(quietTimer);
          quietTimer = setTimeout(finish, EXTRA_WAIT_MS - waited + 50);
          return;
        }
      }

      reveal();
    }

    function settle() {
      clearTimeout(quietTimer);
      quietTimer = setTimeout(finish, QUIET_MS);
    }

    function touchesGrid(node) {
      const el = node.nodeType === 1 ? node : node.parentElement;
      return Boolean(el && (el.closest(GATE_SELECTOR) || (el.querySelector && el.querySelector(GATE_SELECTOR))));
    }

    const observer = new MutationObserver(function (mutations) {
      if (mutations.some(function (m) { return touchesGrid(m.target); })) { settle(); }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    function watchLater() {
      let timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { processButtons(findButtons()); }, 80);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    if (wineClubEligible) {
      validated = true;
      settle();
    } else {
      validateCart().then(function (result) {
        if (result && result.removed) { return; }
        validated = true;
        settle();
      });
    }

    return true;
  }

  const gatedPage = pageGate();

  if (!wineClubEligible) {
    document.addEventListener(
      'ajaxProduct:added',
      async function () {
        await validateCart();
      }
    );

    document.addEventListener(
      'visibilitychange',
      function () {
        if (document.hidden) {
          clearTimeout(watcherTimer);
        } else {
          checkForCartChange();
        }
      }
    );

    if (!gatedPage) {
      validateCart();
    }

    checkForCartChange();
  }

})();